import { baseURL } from '../config';
import IResponse from '../interfaces/IResponse';
import { ITask } from '../interfaces/ITask';
import axios from 'axios';

const BASE_URL = `${baseURL}api/tasks`;

interface IGetAllTasks extends IResponse {
    tasks: ITask[] | null,
}

const getAllTasks = async (): Promise<IGetAllTasks> => {
    const url = BASE_URL;
    try {
        const res = await axios.get(url);
        return {
            tasks: res.data.tasks,
            message: 'Pobrano zadania',
            ok: true,
            status: res.status,
        };
    } catch (error) {
        let message = 'Nie pobrano zadań';
        let status = 400;
        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status) status = error.response.status;
        }
        return {
            message,
            status,
            ok: false,
            tasks: null,
        };
    }
};

interface IAddTask extends IResponse {
    newTask: ITask | null,
}

export interface IAddTaskDto {
    name: string,
    description: string,
    column: "todo" | "inprogress" | "done" | "ideas",
}

const addTask = async (task: IAddTaskDto): Promise<IAddTask> => {
    const url = BASE_URL;
    try {
        const res = await axios.post(url, task);
        return {
            ok: true,
            message: 'Dodano zadanie',
            status: res.status,
            newTask: res.data.task,
        };
    } catch (error) {
        let message = 'Nie dodano zadania';
        let status = 400;
        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status) status = error.response.status;
        }
        return {
            message,
            status,
            ok: false,
            newTask: null,
        };
    }
};

interface IEditTask extends IResponse {
    editedTask: ITask | null,
}

export interface IEditTaskDto {
    _id: string,
    name: string,
    description: string,
}

const editTask = async (task: IEditTaskDto): Promise<IEditTask> => {
    const url = `${BASE_URL}/${task._id}`;
    try {
        const res = await axios.put(url, task);
        return {
            ok: true,
            message: 'Zaktualizowano zadanie',
            status: res.status,
            editedTask: res.data.task,
        };
    } catch (error) {
        let message = 'Nie zaktualizowano zadania';
        let status = 400;
        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 404) message = 'Nie znaleziono zadania';
            if (error.response.status) status = error.response.status;
        }
        return {
            ok: false,
            status,
            message,
            editedTask: null,
        };
    }
};

interface IDeleteTask extends IResponse { }

const deleteTask = async (_id: string): Promise<IDeleteTask> => {
    const url = `${BASE_URL}/${_id}`;
    try {
        const res = await axios.delete(url);
        return {
            ok: true,
            status: res.status,
            message: 'Usunięto zadanie',
        };
    } catch (error) {
        let message = 'Nie usunięto zadania';
        let status = 400;
        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status === 404) message = 'Nie znaleziono zadania';
            if (error.response.status) status = error.response.status;
        }
        return {
            message,
            status,
            ok: false,
        };
    }
};

interface IUpdateManyTasks extends IResponse { }

const updateManyTasks = async (tasks: ITask[]): Promise<IUpdateManyTasks> => {
    const url = BASE_URL;
    try {
        const res = await axios.put(url, { tasks });
        return {
            ok: true,
            status: res.status,
            message: 'Zaktualizowano zadania',
        };
    } catch (error) {
        let message = 'Nie zaktualizowano zadań';
        let status = 400;
        if (axios.isAxiosError(error) && error.response) {
            if (error.response.status) status = error.response.status;
        }
        return {
            message,
            status,
            ok: false,
        };
    }
};

const tasksController = {
    getAllTasks,
    addTask,
    editTask,
    deleteTask,
    updateManyTasks,
};

export default tasksController;